import React, { Component } from 'react';
import EffectMods from 'components/effects/EffectMods.js';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import Dropdown from 'react-dropdown'
import {LFO_COLORS} from './lfo-colors.js';
import {LFO_COMPONENT} from 'constants/contextual-help.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import LFOSyncedTimes from 'components/lfo/LFOSyncedTimes.js';
import LFOShapeDropdown from 'components/lfo/LFOShapeDropdown.js';
import '../../Instruments.scss';
import {setContextualHelp} from "actions/index.js";
import {setSelectedLFO} from "actions/index.js";
import {LFO_MIN_SLIDER} from 'constants/contextual-help.js';
import {LFO_MAX_SLIDER} from 'constants/contextual-help.js';
import { connect } from "react-redux";
import LFOWaveform from './LFOWaveform.js';

class SingleLFOComponent extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            showMods: false,
            waveformData: [],
        };
    }

    onChangeSynced(synced) {
        document.activeElement.blur();
        this.props.lfo.lfo.isSynced = synced === 'unsynced';
        console.log('isSynced is now = ' + this.props.lfo.lfo.isSynced);
        this.setState(this.state);
    }

    onClickModsButton() {
        this.setState({showMods: !this.state.showMods});
    }

    get meter() {
        return this.props.lfo.lfo.meter;
    }

    isSelected() {
        if (this.props.hideSelection) {
            return false;
        }
        return this.props.lfo.lfo.number === this.props.selectedLFO;
    }
    onClick() {
        this.props.setSelectedLFO(this.props.lfo.lfo.number);
        if (this.props.planeMapping) {
            this.props.planeMapping.randomlyMapParameters(
                this.props.lfo.lfo);
        }
    }
    render() {
        let lfo = this.props.lfo.lfo;
        let className = this.isSelected() ? 'lfo-component selected' : 'lfo-component';
        
        if (this.props.planeMapping) {
            className += " plane-mapping";
        }

        if (this.state.showMods) {
            className += " showing-mods";
        }
        return (
            <div 
              onMouseOver={() => this.props.setContextualHelp(LFO_COMPONENT)}
              onMouseLeave={() => this.props.setContextualHelp(undefined)}
              onClick={() => this.onClick()}
              className={className}>
              <div className={"instrument-subsection-name lfo-subsection-name lfo-track-foreground-" + this.props.lfo.number}>
                {this.props.lfo.getName()}
              </div>
              <ConditionedComponent condition={this.state.showMods}>
                <EffectMods parameters={this.props.lfo.lfo.parameters}/>
              </ConditionedComponent>
              <ConditionedComponent condition={!this.state.showMods}>
              <LFOShapeDropdown lfo={lfo}/>
              <div className="clear-fix"/>
              <div className="refined-checkbox-preferences lfo-synced-checkbox">
                      <label>
                        <input 
                          type="checkbox"
                          value={lfo.isSynced ? "synced" : "unsynced"}
                          checked={lfo.isSynced}
                          onChange={(e) => this.onChangeSynced(e.target.value)} />
                          Synced
                      </label>
                    </div>
              {lfo.isSynced ? <LFOSyncedTimes lfo={lfo}/> :
              <EffectParameterSlider
                effectNumber={0}
                name={'Rate'}
                parameter={lfo.lfoRateParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                    sequencerEngine={this.props.sequencerEngine}
                    lfoEnabled={true}
                  step={0.1}
                  min={0}
                  max={32}
                />}
                  <EffectParameterSlider
                    effectNumber={0}
                    name={'Min'}
                    contextualHelp={LFO_MIN_SLIDER}
                    parameter={lfo.lfoMinParameter}
                    sequencerEngine={this.props.sequencerEngine}
                    onParameterChanged={() => []}
                    isParameter={true}
                    lfoEnabled={true}
                    min={-100}
                    max={100}
                    step={1}
                  />
                  <EffectParameterSlider
                    effectNumber={0}
                    name={'Max'}
                    parameter={lfo.lfoMaxParameter}
                    contextualHelp={LFO_MAX_SLIDER}
                    sequencerEngine={this.props.sequencerEngine}
                    onParameterChanged={() => []}
                    lfoEnabled={true}
                    isParameter={true}
                    min={-100}
                    max={100}
                    step={1}
                  />
               <div className="two-parameters">
                  <EffectParameterSlider
                    effectNumber={0}
                    name={'Amp'}
                    parameter={lfo.lfoAmpParameter}
                    contextualHelp={LFO_MAX_SLIDER}
                    sequencerEngine={this.props.sequencerEngine}
                    onParameterChanged={() => []}
                    lfoEnabled={true}
                    isParameter={true}
                    min={0}
                    max={1}
                    step={0.01}
                  />
                <EffectParameterSlider
                    effectNumber={0}
                    name={'Phase'}
                    sequencerEngine={this.props.sequencerEngine}
                    parameter={lfo.lfoPhaseParameter}
                    onParameterChanged={() => []}
                    isParameter={true}
                    min={0}
                    max={360}
                    step={1}
                  />
                </div>
              </ConditionedComponent>
              <div className="mods-button" onClick={() => this.onClickModsButton()}>
                {this.state.showMods ? 'BACK' : 'MODS'}
              </div>
            </div>
        );
              // <LFOWaveform isSelected={this.isSelected()} lfo={this.props.lfo.lfo}/>
    }
}

const mapStateToProps = state => {
    return {
        selectedLFO: state.sequencer.selectedLFO,
        planeMapping: state.effects.planeMapping
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
        setSelectedLFO: (lfo) => dispatch(setSelectedLFO(lfo)),
    };
}
 
export default connect(mapStateToProps, mapDispatchToProps)(SingleLFOComponent);

